module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/edd51aa5e9b5e39664fdc0b5b12a3a52.png";